import { DataSource, Label, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserMapping extends Layout {
    labelMapOptions: Label;
    sourceUserSettings: DataSource;
    switchGoogleMapLayer: Switch;
    switchGoogleShowDisclaimer: Switch;
    switchShowProposedRoute: Switch;
    switchTrimbleMapTraffic: Switch;
    textboxDistanceCalcVendor: Textbox;
    textboxFindnearVendor: Textbox;
    textboxGoogleMapDisplay: Textbox;
    textboxMovementMapVendor: Textbox;
    textboxPartialShipmentVendor: Textbox;
    textboxSinglePointVendor: Textbox;
    textboxViewMovementMapVendor: Textbox;
    textboxZoneMappingVendor: Textbox;
}
